/**
 * Basename for a catalog boat file (`boats/<name>.json`).
 * Shared by the workshop and the DEV write hook so a bad name cannot leave `boats/`.
 */
export function sanitizeBoatFilename(raw: string): string | null {
  const base = raw.trim().replace(/^.*[/\\]/, '');
  const stem = base.replace(/\.json$/i, '');

  if (!/^[A-Za-z0-9][A-Za-z0-9._-]{0,127}$/.test(stem)) {
    return null;
  }

  return `${stem}.json`;
}

export function isSafeBoatFilename(name: string): boolean {
  return sanitizeBoatFilename(name) === name;
}
